import { ModalModule } from 'ngx-bootstrap/modal';

import { FinanceRoutingModule } from './finance-routing.module';
import { SystemCommonModule } from 'src/app/system-common/system-common.module';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BalanceDetailsSearchComponent } from './balance-details-search/balance-details-search.component';
import { PaymentStatementSearchComponent } from './payment-statement-search/payment-statement-search.component';
import { FinanceService } from './services/finance.service';
import { PaymentStatementDetailsSearchComponent } from './payment-statement-details-search/payment-statement-details-search.component';
import { TeamBalanceDetailsSearchComponent } from './team-balance-details-search/team-balance-details-search.component';

@NgModule({
  declarations: [
    BalanceDetailsSearchComponent,
    PaymentStatementSearchComponent,
    PaymentStatementDetailsSearchComponent,
    TeamBalanceDetailsSearchComponent,
  ],
  imports: [CommonModule, SystemCommonModule, FinanceRoutingModule, ModalModule.forRoot()],
  providers: [FinanceService],
})
export class FinanceModule {}
